(ns frontend.ui.page.lp-report-editor.common.modal.style
  (:require
   [frontend.ui.style.theme.core :refer [color text-size]]
   [garden.units :refer [px]]
   [garden.util :refer [space-join]]))

(defn body
  []
  {:padding    "16px 24px"
   :border-top (space-join ["1px solid " (color [:card :body :border-top])])
   :max-height "70vh"
   :overflow-y :auto})

(defn rich-content-list
  []
  {:margin-bottom "24px"
   :margin-top "12px"
   :border (space-join ["1px solid " (color [:card :body :border-top])])})

(defn recipient-list
  []
  {:margin-bottom "16px"
   :flex-flow     "wrap"
   :display       "flex"
   :flex          "0 0 auto"})

(defn recipient-list-item
  []
  {:display "flex"
   :flex    "0 0 auto"
   :padding "8px"
   :border  (space-join ["1px solid " (color [:palette :info])])})

(defn recipient-list-item-skipped
  []
  ^{:extend recipient-list-item}
  {:text-decoration :line-through
   :color           (color [:palette :danger])
   :border-color    (color [:palette :danger])})
